<template>
  <div class="device">
    <commonTable
      ref="commonTable"
      url="/admin/devices/register_info"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
    >
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js";
import commonTable from '@/component/commonTable.vue'
export default {
  name: 'device',
  data () {
    return {
      gameChannelPackageList: [],
      channelList: []
    }
  },
  computed: {
    column () {
      return [
        {
          label: "注册时间",
          prop: "register_date",
        },
        {
          label: "注册设备",
          prop: "register_gdid",
          formatter: (row, column, cellValue) => {
            return (row && row.reg_num === 1 ? '(新设备)' : '') + cellValue
          }
        },
        {
          label: "游戏母包名",
          prop: "game_package.name"
        },
        {
          label: "渠道包ID列表",
          prop: "game_channel_package_id"
        },
        {
          label: "用户ID列表",
          prop: "user_ids"
        },
        {
          label: "累计新增充值",
          prop: "money",
        },
        {
          label: "30天内注册用户数",
          prop: "reg_num",
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: '日期（起）+ 日期（止）',
          prop: 'created_from+created_to',
          type: "date",
          setDefault: true
        },
        {
          label: "渠道包ID",
          prop: "game_channel_package_id",
          type: "select",
          option: this.gameChannelPackageList
        },
        {
          label: "渠道ID",
          prop: "channel_id",
          type: "select",
          option: this.channelList
        },
        {
          label: '用户ID',
          prop: 'user_id',
          type: "input",
        },
      ]
    }
  },
  mounted () {
    this.getGameChannelPackageList()
    this.getChannelList()
  },
  methods: {
    getGameChannelPackageList () {
      fetch({
        url: "/admin/game_channel_packages/list",
        method: "GET",
        params: {
          per_page: 10000
        },
      }).then((res) => {
        if (res.data.status && res.data.data) this.gameChannelPackageList = res.data.data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      })
    },
    getChannelList () {
      fetch({
        url: "/admin/channels/list",
        method: "GET",
        params: {
          per_page: 10000
        },
      }).then((res) => {
        if (res.data.status && res.data.data) this.channelList = res.data.data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      })
    },
  },
  components: {
    commonTable
  }
}
</script>

<style lang="less" scoped>

</style>
